import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import companySign from "../../assets/images/companySign.png";

Font.register({
    family: 'Helvetica',
    fonts: [
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/fonts/helveticaneue.ttf', fontWeight: 'normal' },
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/fonts/helveticaneue-bold.ttf', fontWeight: 'bold' },
    ],
});

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        fontFamily: 'Helvetica',
        padding: 20,

    },
    section: {
        margin: 10,
        flexGrow: 1,
    },
    paragraph: {
        fontSize: 13,
        flexGrow: 1,
    },
    bold: {
        fontFamily: 'Helvetica-Bold',
    },
    mtop: {
        marginTop: 10,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    imgView: {
        height: 200,
    },
    rowImage: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
});

export const MyDocument = ({ user, imageUrl }) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.section}>
                    <Image src={imageUrl} alt='Legal Stamp' />
                </View>
            </Page>

            <Page size="A4" style={styles.page}>
                <View style={styles.paragraph}>
                    <Text style={styles.bold}>Presently It Is In A Position To Procure The Business For Form Filling More Meaningfully Described In The
                        Column Scope Of Work, Through Their Principals. The Current Project Is Carried Out Under The Cost Of Client
                        And Not An Assignment As Such Acquired By Client. AND WHEREAS The Business Associate Is Engaged Inter
                        Alias, In The Business Of Providing A Wide Spectrum Of Software Solutions & Services. The Business
                        Associate Has Acquired The Necessary Expertise And Developed The Requisite Skill Base And Infrastructure
                        For Successful Execution Of Form Filling Projects.
                    </Text>

                    <Text style={[styles.bold, styles.mtop]}>NOW THIS AGREEMENT WITNESSETH AS FOLLOWS:</Text>

                    <Text style={styles.mtop}>
                        1.	Scope Of Work: The Original Data Will Be Available On The Work Environment Web-Portal Provided By {process.env.REACT_APP_COMPANY_NAME} At The Time Of Signup. Client Is Required To Feed The Provided Data In The Provided Portal As Per The
                        Guidelines. Data Supply And Preservation Of The Output File Is Done Online On Real Time Basis.
                    </Text>
                    <Text style={styles.mtop}>
                        2.	Remuneration: For The Form Filling Services Rendered By The Clients, They Shall Be Entitled For Payment Of Price
                        100 per Paragraph Rs. (INR) Max Per Form Which Is Only Being Undertaken To Test The Skills Of The Client.
                        The Business Associate Shall Raise Invoice Every Week With The Data. The Client Will Pay Each Project's Amount
                        Within Maximum 72 HRS, From The Date Of Issue Of Quality Check Report. The Invoice Can Be Raised Through
                        E-mail. Q.C. Report Will Be Provided In 48-72 Working Hours From The Date Of Submission.
                    </Text>
                    <Text style={styles.mtop}>
                        3.	Billing: Client Will Provide Workload Of 250 FORMS In 4 DAYS. This Agreement Has Been Signed For 1 System. The
                        Client Will Make The Payment For The Billing Within 7 Days From Date Of Raising The Project Subject To The Quality
                        Check Report.
                    </Text>
                    <Text style={styles.mtop}>
                        4.	Application Fee(s): The Registration Amount Of 6900 INR. (Monthly Basis) Will Be Deducted From The Salary If
                        Generated, And If The Salary Is Not Generated Then Client Will Have To Pay The Same Registration Amount On Their
                        Own. The Client Must Start & Complete His/Her Work Of Form-Filling Assigned To Them By The Client From The Date
                        Of Starting The Project(Selected By Clients As Per Their Own Convenience) With A Minimum Of 25% Accomplishment
                        Of The Forms Out Of The Total Forms, In Case Of Failure In Starting Of The The Work From Business Associate's End
                        Or "0" Number Of Forms Detected Or Incomplete Submission Of Work Is Defined By The Client Then Application
                        Fee(s) + NOC Invoice Needs To Be Cleared By The Client. As The Client Will Have To Face The Loss In Case Of
                        Failure Of This Project In Any Of The Criteria As Per This Agreement.
                    </Text>
                    <Text style={styles.mtop}>
                        5. Accuracy: : The Client must provide adequate feedback within 15 working days for all data, and upon completion of the quality check, shall issue a quality report. Both parties agree to assure the highest quality of end service, and the following cycle for accuracy will be followed. Cut-off forms - 225 / 250 (in total) - Above 90% @ 100 per paragraph INR per form. If below cut-off or ID terminated, the client will need to clear the registration amount. If you require extra time to complete your work, extension charges will apply.
                    </Text>
                    <Text style={styles.mtop}>
                        The Q.C. Department Will Check The Forms Randomly. Till The Submitted Slot Is Rejected Above The Cut-Off Criteria
                        If Client Makes Any Mistake (which Includes But Not Limited To Spelling, Punctuation, Extra/Missing Space,
                        Extra/Missing Word, Extra/Missing Line Etc.) In A Form That Form Will Be Rejected, Likewise Client Have To Maintain
                        Cut Off Or Accuracy.
                        If All The Forms Are Submitted Or In Submit Mode, Then Only The Q.C. Report Will Be Generated Else Not.
                    </Text>
                    <Text style={styles.mtop}>
                        6.	You have to do the work in Computer , Laptop and SmartPhone ( If you did the multiple login then after your softwere
                        crashed then you are liable to pay the repairing maintenance amount )
                    </Text>
                </View>
            </Page>

            <Page size="A4" style={styles.page}>
                <View style={styles.paragraph}>
                    <Text style={styles.mtop}>
                        7.	TAT (Turn Around Time): The Second Party Has 4 Days(Including Holidays) To Complete The New Work And
                        Second Party Has To Send It To First Party. The First Party Shall Give An Accuracy Report Within 3-4 Working Days
                        For The New Work, After Submissions As Per Technical Specifications Which Are Included In This Agreement With
                        Accuracy Parameters
                    </Text>
                    <Text style={styles.mtop}>
                        8.	Client Agrees To Provide Formats And Other Information For Processing The Job To Business Associate At The Time Of Providing The Data And The Business Associate Agrees The With The Format And Other Information Which Is Being Processed To The Particular.
                    </Text>
                    <Text style={styles.mtop}>
                        9.	Telecommunication Cost Applicable At Each End Shall Be Borne By The Respective Parties.
                    </Text>
                    <Text style={styles.mtop}>
                        10.	Client Will Execute The Data Processing Work Provided By Business Associate Through Experienced Persons In Such Manner So As To Carry Out The Work Efficiently At Minimum Of 90% Accuracy For Out Files.
                    </Text>
                    <Text style={styles.mtop}>
                        11.	This Agreement Represents The Business Agreement And Operational Understandings Between The Parties And Shall Remain In Effect For A Period Of Eleven Months From The Date Of Execution Hereof. The Client's Specifications In Terms Of Quality And Other Parameters That Shall Be Issued By The Client/their Principals From Time To Time And Acknowledged By The Client Shall Be Read With This Agreemen
                    </Text>
                    <Text style={styles.mtop}>
                        12.	It Is Agreed By Parties That The Agreement Is Valid Only For The Trial Assignments Wherein The Business Associate Is Tested. Upon Satisfactory Results, The Business Associate Shall Acquire Data Entry/Form Filing Works From The International Companies At Its Own Cost & Provide Them To The Business Associate.
                    </Text>
                    <Text style={styles.mtop}>
                        13.	Termination: - If Client Fails To Submit Data On Time Or, If Client Fails To Give Accuracy In Output Files. Client Reserves The Right To Terminate The Agreement With Immediate Effect. And {process.env.REACT_APP_COMPANY_NAME} Will Not Be Responsible For Any Further Data And Payment To The Client. And Client Will Be Liable To Pay The Maintenance Amount To The Client As Mentioned In 'Clause-4' In This Agreement And Client Will Also Be Liable To Pay Client's Expenses For Legal Proceedings.
                    </Text>
                    <Text style={styles.mtop}>
                        14.	No Modification Of The Terms Of This AGREEMENT Shall Be Valid Unless It Is In Writing And Signed By Both The Parties.
                    </Text>
                    <Text style={styles.mtop}>
                        15.	Severability: Unenforceability Of Any Provision Of This Agreement Shall Not Affect Any Other Provisions Herein Contained; Instead, This Agreement Shall Be Construed As If Such Unenforceable Provision Had Not Been Contained Herein.
                    </Text>
                    <Text style={styles.mtop}>
                        16.	Variation: Except As Otherwise Expressly Provided In This Agreement, This Agreement May Not Be Changed Or Modified In Any Way After It Has Been Signed, Except In Writing Signed By Or On Behalf Of Both Of The Parties.
                    </Text>
                    <Text style={styles.mtop}>
                        17.	Dispute Resolution & Jurisdiction: In The Event Of Any Dispute Or Difference Arising Between The Parties Hereto Relating To Or Arising Out Of This Agreement, Including The Implementation, Execution, Interpretation, Rectification, Validity, Enforceability, Termination Or Rescission Thereof, Including The Rights, Obligations Or Liabilities Of The Parties Hereto, The Same Will Be Adjudicated And Determined By Arbitration. The Indian Arbitration & Conciliation Act, 1996 Or Any Statutory Amendment Or Re-enactment Thereof In Force In India, Shall Govern The Reference. Both Parties Shall Appoint Their Respective Arbitrator, And Both Arbitrators Thus Appointed Should Appoint The Third Arbitrator Who Shall Function As The Presiding Arbitrator. The Venue Of Arbitration Shall Be Jaipur (Rajasthan). The Courts In The City Of Jaipur Shall Have Exclusive Jurisdiction To Entertain Try And Determine The Same.
                    </Text>
                    <Text style={styles.mtop}>
                        18.	Both The Parties Hereby Agree Neither To Circumvent Or Nor To Disclose The Identities, Information As Well As The Essence Of The Project Etc Of Each Other's/Principals, Clients Etc To Any Other Third Party And Neither Of Us Will Approach Each Other's Contracts As Identified From Time To Time
                    </Text>
                </View>
            </Page>

            <Page size="A4" style={styles.page}>
                <View style={styles.paragraph}>
                    <Text style={styles.bold}>
                        IN WITNESS WHEREOF the parties hereto have executed these presents on the date hereinbefore written: {user?.name}
                    </Text>
                    <View style={styles.row}>
                        <View style={styles.section}>
                            <Text style={[styles.bold, styles.mtop]}>Business Associate:</Text>
                            <Text style={[styles.bold, styles.mtop]}>{process.env.REACT_APP_COMPANY_NAME}</Text>
                            <View style={[styles.imgView, { display: 'flex', justifyContent: 'center' }]}>
                                <Image src={companySign} alt='Company signature' style={{ width: "150px" }} />
                            </View>
                            <Text style={[styles.bold, styles.mtop]}>Authorized Signature</Text>
                        </View>
                        <View style={styles.section}>
                            <Text style={[styles.bold, styles.mtop]}>Client:</Text>
                            <Text style={[styles.bold, styles.mtop]}>{user?.name}</Text>
                            <View style={[styles.rowImage, styles.imgView, { display: 'flex', alignItems: 'center' }]}>
                                <Image src={user?.signatureDataUrl} alt='Client Signature' style={{ width: "120px" }} />
                                <Image src={user?.photoDataUrl} alt='Client Signature' style={{ width: "120px" }} />
                            </View>
                            <Text style={[styles.bold, styles.mtop]}>Authorized Signature</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
}